// extracted by mini-css-extract-plugin
module.exports = {"profile":"profile_profile__3KEo9","link":"profile_link__2uXN1","media":"profile_media__1hYim"};